import { apiGet, apiPost, apiDelete, unwrap } from './apiClient';
import type {
  ResponseDTO,
  AdeProfileDefineRequestDTO,
  AdeProfileDefineResponseDTO,
  AdeProfileResponseDTO,
  AdeProfileAssignRequestDTO,
  AdeProfileAssignResponseDTO,
} from '@/types/api';

const BASE = '/api/v1/ade';
const ACCOUNTS_BASE = `${BASE}/accounts`;

/** List all profiles across all ADE accounts */
export async function listAllProfiles() {
  const res = await apiGet<ResponseDTO<AdeProfileResponseDTO[]>>(
    `${BASE}/profiles`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function createAdeProfile(adeAccountId: string, body: AdeProfileDefineRequestDTO) {
  const res = await apiPost<ResponseDTO<AdeProfileDefineResponseDTO>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function listAdeProfiles(adeAccountId: string) {
  const res = await apiGet<ResponseDTO<AdeProfileResponseDTO[]>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getAdeProfile(adeAccountId: string, profileId: string) {
  const res = await apiGet<ResponseDTO<AdeProfileResponseDTO>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles/${profileId}`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function deleteAdeProfile(adeAccountId: string, profileId: string) {
  return apiDelete<ResponseDTO<null>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles/${profileId}`,
    undefined,
    { includeTenantHeader: true }
  );
}

export async function assignProfileToDevices(
  adeAccountId: string,
  profileId: string,
  body: AdeProfileAssignRequestDTO
) {
  const res = await apiPost<ResponseDTO<AdeProfileAssignResponseDTO>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles/${profileId}/devices`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function removeProfileFromDevices(
  adeAccountId: string,
  profileId: string,
  body: AdeProfileAssignRequestDTO
) {
  const res = await apiDelete<ResponseDTO<AdeProfileAssignResponseDTO>>(
    `${ACCOUNTS_BASE}/${adeAccountId}/profiles/${profileId}/devices`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
